import { render, staticRenderFns } from "./AutoconsoCard.vue?vue&type=template&id=052be1c3"
import script from "./AutoconsoCard.vue?vue&type=script&lang=js"
export * from "./AutoconsoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports